module.exports = __webpack_public_path__ + "static/media/coffee.cafc5da9.svg";